import { render, staticRenderFns } from "./mspVideos.vue?vue&type=template&id=15d906d2"
import script from "./mspVideos.vue?vue&type=script&lang=js"
export * from "./mspVideos.vue?vue&type=script&lang=js"
import style0 from "./mspVideos.vue?vue&type=style&index=0&id=15d906d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports